import React, { createContext, useContext, useEffect, useState, useCallback } from 'react';
import api from '../lib/api';
import { useAuth } from './AuthContext';

const BrandContext = createContext(null);

const DEFAULT_BRAND = {
  facilityName: '',
  logo: '',
  primaryColor: '#0D9488',
  colors: ['#0D9488', '#2563EB', '#7C3AED', '#D97706', '#059669', '#DC2626'],
};

export function BrandProvider({ children }) {
  const { user } = useAuth();
  const [brand, setBrand] = useState(DEFAULT_BRAND);

  const refresh = useCallback(async () => {
    try {
      const r = await api.get('/settings/brand');
      setBrand({ ...DEFAULT_BRAND, ...r.data, loaded: true });
    } catch {
      setBrand({ ...DEFAULT_BRAND, loaded: true });
    }
  }, []);

  useEffect(() => {
    const active = user && (user.role === 'owner' || user.status === 'active');
    if (active) refresh();
  }, [user, refresh]);

  return <BrandContext.Provider value={{ brand, setBrand, refresh }}>{children}</BrandContext.Provider>;
}

export function useBrand() {
  return useContext(BrandContext) || { brand: DEFAULT_BRAND, refresh: () => {} };
}
